import {styled} from "@mui/material/styles";

/* Theme for the custom Breadcrumbs component */

export const CrumbText = styled("span")(({theme}) => ({
    color: theme.palette.text.primary, fontSize: theme.spacing(2), fontWeight: theme.typography.fontWeightMedium,
}));

export const breadcrumbsSx = (t: any) => ({
    p: t.spacing(2, 2, 2, 0), "& .MuiBreadcrumbs-separator": {m: 0},
});